import React, { useEffect, useRef, useState } from 'react'
import Freedelivery from "../../../assets/img/app/transport.png"
import Returnorder from "../../../assets/img/app/return-box.png"
import Cardpayment from '../../../assets/img/app/card.png'
import Support from '../../../assets/img/app/24-hours-support.png'
import { get_return_policy } from '../../../api/category_product/Category_Product'
import parse from 'html-react-parser';
import { useNavigate } from 'react-router-dom'

const Product_Return_Policy = () => {
    const [get_return_policy_list, set_Return_Policy_List] = useState();
    const [showKnowMore, setShowKnowMore] = useState(false);
    const textRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const handle_get_return_policy = async () => {
            try {
                const response = await get_return_policy();
                set_Return_Policy_List(response?.data?.data);
            }
            catch (error) {
                console.error("error", error)
            }
        }
        handle_get_return_policy();
    }, [])

    const shippingPolicy = get_return_policy_list?.find(
        (type) => type?.page_type === "shipping_policy"
    );

    const returnPolicy = get_return_policy_list?.find(
        (type) => type?.page_type === "return_policy"
    );

    const paymentMethod = get_return_policy_list?.find(
        (type) => type?.page_type === "payment_method"
    );


    useEffect(() => {
        if (textRef.current) {

            const isOverflowing =
                textRef.current.scrollHeight > textRef.current.clientHeight;
            setShowKnowMore(isOverflowing);
        }
    }, [shippingPolicy]);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div>
            <section className="gi-deal-section">
                <div className="flex flex-wrap justify-between items-center">
                    <div className="rounded-lg overflow-hidden">
                        <div className="grid lg:grid-cols-3">
                            <div>
                                <div className="svg_icon_heading flex gap-5 items-center font-semibold text-[14px] text-gray-900/80 bg-gray-100 p-4 py-2">
                                    <svg width="24" height="24" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2 3V1H11V9" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M4 9H2V7" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M11 2H14V5L16 6V9H14" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M5.5 10.5C6.32843 10.5 7 9.82843 7 9C7 8.17157 6.32843 7.5 5.5 7.5C4.67157 7.5 4 8.17157 4 9C4 9.82843 4.67157 10.5 5.5 10.5Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M12.5 10.5C13.3284 10.5 14 9.82843 14 9C14 8.17157 13.3284 7.5 12.5 7.5C11.6716 7.5 11 8.17157 11 9C11 9.82843 11.6716 10.5 12.5 10.5Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M7 9H11" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M1 3H7" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M1 5H5" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M1 7H3" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <h2 className='font-bold text-gray-900'>Shipping Policy</h2>
                                </div>
                                <div className='p-3 font-normal bg-white '>
                                    <div className="sub__title text-gray-600 text-[13px] line-clamp-3">
                                        {shippingPolicy?.description
                                            ? parse(shippingPolicy.description)
                                            : "No shipping policy found."}
                                    </div>
                                </div>
                                <div className="text-[13px] bg-white p-3 ">
                                    <button
                                        onClick={() => navigate(`/shipping-policy`)}
                                        className="text-gray-800 hover:text-red-700 text-[12px] font-semibold hover:font-medium"
                                    >
                                        Know More
                                    </button>
                                </div>
                            </div>
                            <div className="border-r border-gray-300 border-l border-gray-300">
                                <div className="svg_icon_heading flex gap-5 items-center font-semibold text-[14px] text-gray-900/80 bg-gray-100 p-4 py-2">
                                    <svg width="203" height="204" viewBox="0 0 203 204" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M102.041 203.107C129.038 203.107 154.412 192.585 173.533 173.464C191.27 155.727 201.732 132.157 202.995 107.083C203.115 104.618 201.191 102.454 198.726 102.333C196.261 102.213 194.096 104.137 193.976 106.602C192.834 129.391 183.273 150.856 167.099 167.031C149.722 184.407 126.573 194.028 101.981 194.028C77.3886 194.028 54.2394 184.468 36.8626 167.031C0.96637 131.134 0.96637 72.6903 36.8626 36.7942C67.4675 6.18921 115.089 1.07836 151.285 24.1072L141.124 36.5536L170.286 33.6074L167.339 4.44551L157.058 17.0723C117.193 -8.90282 64.3409 -3.43121 30.489 30.4206C-8.95468 69.8643 -8.95468 133.96 30.489 173.404C49.6697 192.585 75.0436 203.107 102.041 203.107Z" fill="black" />
                                        <path d="M149.72 81.1638C149.72 81.1037 149.72 81.0436 149.66 81.0436C149.66 80.9233 149.6 80.8632 149.6 80.7429C149.6 80.6828 149.54 80.5625 149.54 80.5024C149.54 80.4423 149.48 80.3822 149.48 80.322C149.359 80.0214 149.239 79.7809 149.059 79.5404L129.938 51.4608C129.096 50.1981 127.713 49.4766 126.21 49.4766H77.7473C76.2441 49.4766 74.8612 50.1981 74.0194 51.4608L54.8988 79.4802C54.7185 79.7208 54.5982 80.0214 54.478 80.2619C54.478 80.322 54.4178 80.3822 54.4178 80.4423C54.3577 80.5024 54.3577 80.6227 54.3577 80.6828C54.3577 80.8031 54.2976 80.8632 54.2976 80.9834C54.2976 81.0436 54.2976 81.1037 54.2375 81.1037C54.1773 81.4043 54.1172 81.705 54.1172 82.0056V149.89C54.1172 152.355 56.1615 154.399 58.6268 154.399H145.271C147.736 154.399 149.78 152.355 149.78 149.89V82.0657C149.78 81.705 149.78 81.4043 149.72 81.1638ZM80.1524 58.4957H123.805L136.733 77.496H67.1649L80.1524 58.4957ZM140.761 145.44H63.1965V86.5753H140.821V145.44H140.761Z" fill="black" />
                                    </svg>
                                    <h3 className='font-bold text-gray-900'>Return Policy</h3>
                                </div>
                                <div className='p-3 font-normal bg-white '>
                                    <div className="sub__title text-gray-600 text-[13px] line-clamp-3">
                                        {returnPolicy?.description
                                            ? parse(returnPolicy.description)
                                            : "No return policy found."}
                                    </div>
                                </div>
                                <div className="text-[13px] bg-white p-3 ">
                                    <button
                                        onClick={() => navigate(`/return-policy`)}
                                        className="text-gray-800 hover:text-red-700 text-[12px] font-semibold hover:font-medium"
                                    >
                                        Know More
                                    </button>
                                </div>
                            </div>
                            <div>
                                <div className="svg_icon_heading flex gap-5 items-center font-semibold text-[14px] text-gray-900/80 bg-gray-100 p-4 py-2">
                                    <svg width="48" height="34" viewBox="0 0 48 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M46.4008 4.29844V1.59844C46.4008 1.49844 46.3008 1.39844 46.2008 1.39844H7.50078C7.40078 1.39844 7.30078 1.49844 7.30078 1.59844V4.29844" stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                        <path d="M17.3008 32.6H46.2008C46.3008 32.6 46.4008 32.5 46.4008 32.4V7.2C46.4008 7.1 46.3008 7 46.2008 7H7.50078C7.40078 7 7.30078 7.1 7.30078 7.2V10.6" stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                        <path d="M41.7992 26.7969H37.6992" stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                        <path d="M35.7016 26.7969H31.6016" stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                        <path d="M29.5023 26.7969H26.9023" stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                        <path d="M32.6992 19.2V14.2C32.6992 14.1 32.7992 14 32.8992 14H40.6992C40.7992 14 40.8992 14.1 40.8992 14.2V19.2C40.8992 19.3 40.7992 19.4 40.6992 19.4H32.8992C32.6992 19.4 32.6992 19.3 32.6992 19.2Z" stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                        <path d="M7.5 20.3953L10 22.8953L14.7 18.1953" stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                        <path d="M17.0016 28.8969L11.6016 32.5969H11.5016L6.10156 28.8969C3.30156 26.9969 1.60156 23.7969 1.60156 20.3969V12.5969C1.60156 12.3969 1.70156 12.2969 1.90156 12.2969H21.2016C21.4016 12.2969 21.5016 12.3969 21.5016 12.5969V20.3969C21.5016 23.7969 19.8016 26.9969 17.0016 28.8969Z" stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                        <path d="M11.5008 26.7984C14.9249 26.7984 17.7008 24.0226 17.7008 20.5984C17.7008 17.1743 14.9249 14.3984 11.5008 14.3984C8.07662 14.3984 5.30078 17.1743 5.30078 20.5984C5.30078 24.0226 8.07662 26.7984 11.5008 26.7984Z" stroke="black" stroke-width="2" stroke-miterlimit="10" />
                                    </svg>

                                    <h4 className='font-bold text-gray-900'>Payment Method</h4>
                                </div>
                                <div className='p-3 font-normal bg-white '>
                                    <div className="sub__title text-gray-600 text-[13px] line-clamp-3">
                                        {paymentMethod?.description
                                            ? parse(paymentMethod.description)
                                            : "No payment method found."}

                                    </div>
                                </div>
                                <div className="text-[13px] bg-white p-3 ">
                                    <button
                                        onClick={() => navigate(`/payment-method`)}
                                        className="text-gray-800 hover:text-red-700 text-[12px] font-semibold hover:font-medium"
                                    >
                                        Know More
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>

    )
}

export default Product_Return_Policy
